import { render, staticRenderFns } from "./CompanyAttachments.vue?vue&type=template&id=fd7597d4&scoped=true&"
import script from "./CompanyAttachments.vue?vue&type=script&lang=js&"
export * from "./CompanyAttachments.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAttachments.vue?vue&type=style&index=0&id=fd7597d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7597d4",
  null
  
)

export default component.exports